import { useEffect } from 'react';
import { Platform } from 'react-native';

export function useOnKeyPress(
  onKeyPress: (evt: KeyboardEvent) => void,
  enabled: boolean = true
) {
  useEffect(() => {
    if (!enabled || Platform.OS !== 'web') return;

    const onDocumentKeyUp = (evt: KeyboardEvent) => {
      onKeyPress?.(evt);
    };

    document.addEventListener('keyup', onDocumentKeyUp);

    return () => {
      document.removeEventListener('keyup', onDocumentKeyUp);
    };
  }, [enabled, onKeyPress]);
}
